var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Card, getTestId, Scrollable, useBreakpoint } from '@airtel/air-design-system';
import { View } from 'react-native';
import { getAccordionListWidgetStyles } from '../../AccordionListWidgetStyles';
import { DataList } from '../data-list/DataList';
export var AccordionComponentWrapper = _a => {
  var data = _a.data,
    _a$initialItemsCount = _a.initialItemsCount,
    initialItemsCount = _a$initialItemsCount === void 0 ? 0 : _a$initialItemsCount,
    testID = _a.testID,
    cardProps = _a.cardProps,
    _a$withoutScrollView = _a.withoutScrollView,
    withoutScrollView = _a$withoutScrollView === void 0 ? false : _a$withoutScrollView,
    style = _a.style,
    _a$expandCtaText = _a.expandCtaText,
    expandCtaText = _a$expandCtaText === void 0 ? 'View All' : _a$expandCtaText,
    _a$parentIndex = _a.parentIndex,
    parentIndex = _a$parentIndex === void 0 ? '' : _a$parentIndex,
    onViewAllPressHandler = _a.onViewAllPressHandler,
    showViewAllCta = _a.showViewAllCta,
    selectedAccordion = _a.selectedAccordion,
    collapseAll = _a.collapseAll,
    onViewableItemsChanged = _a.onViewableItemsChanged,
    onUserAction = _a.onUserAction,
    itemCount = _a.itemCount,
    restProps = __rest(_a, ["data", "initialItemsCount", "testID", "cardProps", "withoutScrollView", "style", "expandCtaText", "parentIndex", "onViewAllPressHandler", "showViewAllCta", "selectedAccordion", "collapseAll", "onViewableItemsChanged", "onUserAction", "itemCount"]);
  var accordionListWidgetStyles = getAccordionListWidgetStyles();
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var AccordionWrapper = withoutScrollView ? View : Scrollable;
  return _jsx(AccordionWrapper, Object.assign({
    style: style
  }, !withoutScrollView && {
    keyboardShouldPersistTaps: 'handled'
  }, restProps, getTestId(testID, 'accordionWrapper'), !withoutScrollView && {
    variant: 'flatList'
  }, {
    onViewableItemsChanged: onViewableItemsChanged,
    showScrollbar: false
  }, {
    children: _jsxs(Card, Object.assign({
      noPadding: true
    }, cardProps, getTestId(testID, 'card'), {
      children: [_jsx(DataList, Object.assign({
        data: data,
        isLevel2: false,
        parentIndex: parentIndex,
        selectedAccordion: selectedAccordion,
        collapseAll: collapseAll,
        onUserAction: onUserAction,
        initialItemsCount: initialItemsCount,
        itemCount: itemCount,
        testID: testID
      }, restProps)), (data === null || data === void 0 ? void 0 : data.length) > initialItemsCount && showViewAllCta && _jsx(View, Object.assign({
        style: accordionListWidgetStyles.viewAllCta
      }, {
        children: _jsx(Button, Object.assign({
          buttonType: "tertiary",
          iconName: "DownChevronButtonIcon",
          iconPosition: "right",
          size: isSmallScreen ? 'md' : 'lg',
          title: expandCtaText,
          onPress: () => onViewAllPressHandler(data, parentIndex)
        }, getTestId(testID, 'viewAllCta')))
      }))]
    }))
  }));
};